export enum AnalyticsGraphName {
  SUMMARY = 'summary',
  ORDERS_BY_COUNTRY = 'order_by_country',
  ORDERS_BY_PRODUCT = 'order_by_product',
  PRINT_COST = 'print_cost',
  SHIPPING_COST = 'shipping_cost',
}
